export const FIELD_INITIAL = 'De';
export const FIELD_FINAL = 'Até';
export const RATE = 'Taxa';
export const TRASH_HINT = 'Excluir Faixa';
